import api from "store/api/api";

//  Get location
export const GET_LOCATIONS = (params) => api.get("/user/location", { params });
